<div class="modal-body relative">
  <header class="header modal-header flex flex-col gap-2 place-content-between">
    <div class="flex justify-between">
      <h2 class="modal-headline uppercase">Asset Download</h2>
      <button mat-icon-button mat-dialog-close class="button-close">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </div>
  </header>
  <form [formGroup]="downloadForm">
    <div class="flex-col gap-3 bg-white h-full">
      <div class="modal-main flex justify-between w-full !min-h-[300px]">
        <div class="flex flex-col mx-4 w-full max-h-[450px] overflow-scroll">
          <div class="flex">
            <div class="w-3/4">
              <mat-checkbox (change)="checkAll($event.checked)" [indeterminate]="someComplete()" [checked]="allComplete">
                <span class="font-bold" *ngIf="!allComplete">Alles auswählen ({{ assets.length }})</span>
                <span class="font-bold" *ngIf="allComplete">Alle assets ({{ assets.length }})</span>
              </mat-checkbox>
            </div>
            <div class="w-1/4 flex items-center">
              <span class="font-bold">Gültig bis</span>
            </div>
          </div>
          <div class="flex" *ngFor="let asset of assets">
            <div class="w-3/4">
              <mat-checkbox class="ml-5" (change)="checkboxClick(asset._id)" [checked]="getCheckedStatus(asset._id)">
                <span>{{ asset.name }}</span>
              </mat-checkbox>
            </div>
            <div class="w-1/4 flex items-center">
              <span>{{ (asset.expiryDate ? asset.expiryDate : info.annahmeschluss) | spDateFormat }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="modal-footer flex flex-row !justify-between w-full gap-4 h-[10%] !items-end sticky bottom-0 bg-white z-50 flex-1">
    <mat-checkbox class="grow" (change)="checkboxTermsClick()" [checked]="downloadForm.get('expiryAndTerms')?.value">
      <span
        ><ng-container i18n>Ich akzeptiere</ng-container>&nbsp;<span class="underline cursor-pointer" (click)="openTerms($event)" i18n
          >die Gültigkeit der Assets und die Nutzungsbedingungen*</span
        ></span
      >
    </mat-checkbox>
    <div class="ml-auto">
      <button (click)="onSubmit()" class="button-primary" mat-flat-button [attr.data-test-id]="'asset-upload_button_upload'" [disabled]="!downloadForm.valid">
        <ng-container i18n>Download</ng-container>
        <mat-icon class="material-icons-outlined ml-2 shrink-0">file_download</mat-icon>
      </button>
    </div>
  </div>
</div>
